import type { TypographyVariantsOptions } from '@mui/material';
import { type } from '../../tokens/type';
import { breakpoints } from './breakpoints';
import { fontWeights } from './fontWeights';

export const typography: TypographyVariantsOptions = {
  fontFamily: 'Roobert',
  fontWeightLight: fontWeights.light,
  fontWeightRegular: fontWeights.regular,
  fontWeightMedium: fontWeights.medium,
  fontWeightSemibold: fontWeights.semibold,
  fontWeightBold: fontWeights.bold,
  fontWeightHeavy: fontWeights.heavy,
  h1: {
    ...type['40_medium'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: { ...type['56_medium'] },
    [`@media (min-width:${breakpoints.values.lg}px)`]: { ...type['64_medium'] },
  },
  h2: {
    ...type['32_medium'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: { ...type['40_medium'] },
    [`@media (min-width:${breakpoints.values.lg}px)`]: { ...type['56_medium'] },
  },
  h3: {
    ...type['24_medium'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: { ...type['28_medium'] },
    [`@media (min-width:${breakpoints.values.lg}px)`]: { ...type['32_medium'] },
  },
  h4: {
    ...type['18_medium'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: { ...type['20_medium'] },
    [`@media (min-width:${breakpoints.values.lg}px)`]: { ...type['24_medium'] },
  },
  h4Hyperlink: {
    ...type['18_medium-hyperlink'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['20_medium-hyperlink'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['24_medium-hyperlink'],
    },
  },
  h5: {
    ...type['16_medium'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: { ...type['18_medium'] },
    [`@media (min-width:${breakpoints.values.lg}px)`]: { ...type['20_medium'] },
  },
  bodyHyperlink: {
    ...type['14_medium-hyperlink'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['16_medium-hyperlink'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['20_medium-hyperlink'],
    },
  },
  bodyLg: {
    ...type['18_regular'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['20_regular'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['24_regular'],
    },
  },
  bodyMd: {
    ...type['14_regular'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['16_regular'],
    },
    [`@media (min-width:${breakpoints.values.md}px)`]: {
      ...type['16_regular'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['18_regular'],
    },
  },
  bodySm: {
    ...type['12_regular'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['14_regular'],
    },
    [`@media (min-width:${breakpoints.values.md}px)`]: {
      ...type['14_regular'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['16_regular'],
    },
  },
  note: {
    ...type['12_footnote'],
  },
  captionSemibold: {
    ...type['16_semibold'],
  },
  eyebrow: {
    ...type['12_semibold'],
    textTransform: 'uppercase',
  },
  quote: {
    ...type['24_regular'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['40_regular'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['44_regular'],
    },
  },
  chip: {
    ...type['12_chip'],
  },
  bodySmHyperlink: {
    ...type['12_medium-hyperlink'],
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      ...type['14_medium-hyperlink'],
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      ...type['16_medium-hyperlink'],
    },
  },

  // disabling all unsupported variants
  h6: undefined,
  subtitle1: undefined,
  subtitle2: undefined,
  body1: undefined,
  body2: undefined,
  caption: undefined,
  button: undefined,
  overline: undefined,
};
